import React from 'react';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import { SimpleInput } from 'apps/sigma2-ui/src/components/ui/SimpleInput';
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { OnOrganizationSecretEditCompleteFn } from 'apps/sigma2-ui/src/secrets/lib/types';
import { useOrganizationSecretEditComponent } from 'apps/sigma2-ui/src/secrets/lib/useOrganizationSecretEditComponent';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';

export const OrganizationSecretEditComponent = ({
  editSecretId,
  organizationId,
  onComplete,
}: {
  editSecretId: string;
  organizationId: string;
  onComplete: OnOrganizationSecretEditCompleteFn;
}) => {
  const {
    editSecretDescription,
    setEditSecretDescription,
    editSecretValue,
    setEditSecretValue,
    editSecretTitle,
    editSecretButtonLabel,
    editSecretButtonBehavior,
    editSecretDescriptionLabel,
    editSecretValueLabel,
    editSecretValueOperationLabel,
    editSecretValueOperation,
    setEditSecretValueOperation,
    editSecretValueOperations,
    editSecretButtonDisabled,
  } = useOrganizationSecretEditComponent({
    organizationId,
    editSecretId,
    onComplete,
  });

  return (
    <Spacing size={'md'} direction={'vertical'}>
      <Paragraph>{editSecretTitle}</Paragraph>

      <Spacing size={'md'} direction={'horizontal'}>
        <SimpleInput
          label={editSecretDescriptionLabel}
          value={editSecretDescription}
          onChange={setEditSecretDescription}
        />
      </Spacing>

      <SelectBoxWithSearch
        type={'single'}
        label={editSecretValueOperationLabel}
        selected={editSecretValueOperation}
        setSelected={setEditSecretValueOperation}
        list={editSecretValueOperations}
      />

      {editSecretValueOperation === 'edit' && (
        <SimpleInput
          label={editSecretValueLabel}
          value={editSecretValue ?? ''}
          onChange={setEditSecretValue}
        />
      )}

      <Button
        behavior={editSecretButtonBehavior}
        text={editSecretButtonLabel}
        disabled={editSecretButtonDisabled}
      />
    </Spacing>
  );
};
